// Builds the "Service Descriptions" segment of a service request title.
// Order follows titleFieldsString (TITLE_FIELDS_STRING env, comma-separated),
// not the storage order of `data` - keeps the title stable regardless of how
// fields were added/reordered in the workflow config.
//
// A top-level entry (e.g. "Offerings") gates its children - if its key is
// listed in titleFieldsString, ALL of its children are included, formatted
// individually. This matters for groups whose children are dynamic/unbounded
// (e.g. Offerings' selected food items), which can't each be enumerated in
// titleFieldsString. Children that ARE individually listed (e.g. the Changi
// Orderings sub-items) are additionally sorted by their titleFieldsString
// position; children not listed keep their original relative order.
const isNA = value => (Array.isArray(value) ? value.includes('NA') : value === 'NA')

const formatItem = item => {
  if (item.key === 'BP & Transport' && isNA(item.value)) return null

  if (Array.isArray(item.value)) {
    return item.value.length ? item.value.join(', ') : null
  }
  if (item.value) {
    if (item.type === 'increment') {
      return Number(item.value) !== 0 ? `${item.key} x${item.value}` : null
    }
    return `${item.key} ${item.value}`
  }
  return null
}

const collectValues = (item, data, titleArray) => {
  const children = data.filter(o => o.parent === item.id)
  if (!children.length) {
    const value = formatItem(item)
    return value ? [value] : []
  }

  const orderIndex = key => {
    const i = titleArray.indexOf(key)
    return i === -1 ? Infinity : i
  }
  const sortedChildren = [...children].sort((a, b) => orderIndex(a.key) - orderIndex(b.key))

  return sortedChildren.flatMap(child => collectValues(child, data, titleArray))
}

export const buildServiceDescriptionTitle = (data, titleFieldsString) => {
  const titleArray = (titleFieldsString || '').split(',')

  const topLevelItems = data
    .filter(o => !o.parent && titleArray.includes(o.key))
    .sort((a, b) => titleArray.indexOf(a.key) - titleArray.indexOf(b.key))

  const parts = topLevelItems.flatMap(item => collectValues(item, data, titleArray))

  return parts.join('+')
}

export default buildServiceDescriptionTitle
